import { render } from "./index.vue?vue&type=template&id=a4a4ded6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a4a4ded6&lang=less&rel=stylesheet%2Fless&scoped=true"
import "./index.vue?vue&type=style&index=1&id=a4a4ded6&lang=less&rel=stylesheet%2Fless"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a4ded6"]])

export default __exports__